import _ from 'lodash';

export default {
  computed: {
    blogItem() {
      return this.$store.state.blogItem;
    },
    blogItemRevisions() {
      return this.$store.state.blogItemRevisions;
    },
    selectedRevision() {
      return _.find(this.blogItemRevisions, { selected: true });
    },
    blogHidden: {
      get() {
        return this.$store.state.blogItem.hidden === 'true';
      },
      set(hidden) {
        this.$store.state.blogItem.hidden = hidden
          ? 'true'
          : 'false';
      },
    },
  },
  methods: {
    selectRevision(revision) {
      _.each(this.blogItemRevisions, (rev) => {
        this.$set(rev, 'selected', false);
      });

      this.$set(revision, 'selected', true);
    },
    createBlogItem() {
      this.$store.dispatch('setBlogItemImageSrc')
        .then(() => {
          this.$store.dispatch('createBlogItem')
            .then(() => {
              this.goToBlogList();
            });
        });
    },
    updateBlogItem() {
      this.$store.dispatch('setBlogItemImageSrc')
        .then(() => {
          this.$store.dispatch('updateBlogItem')
            .then(() => {
              this.goToBlogList();
            });
        });
    },
    updateActiveBlogItemVersion() {
      this.$store.dispatch('updateActiveBlogItemVersion', this.selectedRevision)
        .then(() => {
          this.goToBlogList();
        });
    },
    setCropImageTempSrc(imageSrc) {
      const payload = { imageSrc, imageMode: 'crop' };
      this.$store.dispatch('setCropImageTempSrc', payload);
    },
    clearCropImageTempSrc() {
      this.$store.dispatch('clearCropImageTempSrc');
    },
    cropImage() {
      this.$store.dispatch('cropImage');
    },
    cropAndSaveImage() {
      this.$store.dispatch('cropImage');
      this.$store.commit('setBlogItemImageSrc', this.$store.state.cropImageInformation.imageSrc);
    },
    determineRecommendedImageSize() {
      const height = this.$store.state.blogImageDimensions.blogImageHeight;
      const width = this.$store.state.blogImageDimensions.blogImageWidth;

      let formattedResult = '';
      if (height !== undefined && width !== undefined) {
        formattedResult = `${width}w x ${height}h`;
      } else if (width !== undefined) {
        formattedResult = `${width}w`;
      } else {
        formattedResult = `${height}h`;
      }

      return formattedResult;
    },
  },
};
